import { call, takeLatest, put, select } from 'redux-saga/effects'
import { actionTypes, updateFoodState } from '../actions/cartActions'
import { sendRequest } from '../services/apiService'
import { getRestaurantInfo } from './selectors'
import apiConfig from '../constants/apiConfig'
import { REFRESH_DATA } from '../actions/actionTypes'
import paths from '../routes/paths'
import { getRestaurantId } from '../selectors'

function* _getFoodState({ payload: { params, onDone } }) {
    const {
        accountId,
        hash,
        tableOrdersId,
        verificationCode,
    } = yield select(getRestaurantInfo);
    const restaurantId = yield select(getRestaurantId);
    const { tableOrderDataId } = params
    const { success, responseData } = yield call(
        sendRequest,
        apiConfig.food.getFoodState,
        {
            accountId,
            restaurantId,
            hash,
            tableOrdersId,
            verificationCode,
            tableOrderDataId,
        }
    )
    if (success && responseData.result) {
        yield put(
            updateFoodState({
                ...responseData.data,
                ...params,
            })
        )
    } else if (responseData.code === 'ERR-001') {
        yield put({ type: REFRESH_DATA })
        window.location.replace(paths.notFound)
    }
    if (typeof onDone === 'function') {
        onDone()
    }
}

function* _retryOrder({ payload: { params, onDone } }) {
    const { accountId, hash, verificationCode } = yield select(getRestaurantInfo);
    const restaurantId = yield select(getRestaurantId);
    const { tableOrderDataId } = params
    yield call(sendRequest, apiConfig.food.retryOrder, {
        accountId,
        restaurantId,
        hash,
        verificationCode,
        tableOrderDataId,
    })
    if (typeof onDone === 'function') {
        onDone()
    }
}

const sagas = [
    takeLatest(actionTypes.GET_FOOD_STATE, _getFoodState),
    takeLatest(actionTypes.RETRY_ORDER, _retryOrder),
]

export default sagas
